const es = {
  GO_TO_COURSE_DETAIL: 'Ver detalles del curso',
  GO_TO_COURSE_DETAIL_SHORT: 'Ver detalles',
  SEARCH_COURSE_BY: 'Por',
};

export default es;
